import React from 'react'
import { Mutation, Query } from '@apollo/client/react/components'
import { UPDATE_OWN_INTAKE_MUTATION } from '../../mutations/UPDATE_OWN_INTAKE_MUTATION'
import { GET_OWN_INTAKE_QUERY } from '../../queries/GET_OWN_INTAKE_QUERY'
import { GetOwnIntakeQuery, UpdateOwnIntakeMutation, UpdateOwnIntakeMutationVariables } from '../../schema/schemaTypes'
import { IIntakeStep } from './IIntakeStep'
import { IntakeManager } from './IntakeManager'

interface IProps {
  nextPage: string
  steps: IIntakeStep[]
}

export const IntakeContainer = ({ nextPage, steps }: IProps) => (
  <Mutation<UpdateOwnIntakeMutation, UpdateOwnIntakeMutationVariables> mutation={UPDATE_OWN_INTAKE_MUTATION}>
    {(updateOwnIntake) => (
      <Query<GetOwnIntakeQuery> query={GET_OWN_INTAKE_QUERY}>{({ data, loading, error }) => {
        if (loading) { return null }
        if (error || !data || !data.getOwnIntake) { location.reload() }
        const intake = data!.getOwnIntake!
        return (
          <IntakeManager intake={intake} steps={steps} updateOwnIntake={updateOwnIntake} nextPage={nextPage} />
        )
      }}</Query>
    )}
  </Mutation>
)



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeContainer.tsx